import { KYMW0C00Model } from '../kymw0c00.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画像作成指示画面　画像情報管理を取得するサービス
 *
 * @export GetImageInfoService
 * @class GetImageInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetImageInfoService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW0C00Model}
   * @memberof GetImageInfoService
   */
  private model: KYMW0C00Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetImageInfoService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetImageInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ImageID: this.model.imageID
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetImageInfoService
   */
  execute(model: any, successFunc: Function): void {
    this.model = <KYMW0C00Model>model;
    this.successFunc = successFunc;
    this.send('KYMW0C00GetImageInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetImageInfoService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
